import { MouseWheelBehaviors } from "yfiles";
export default (graphComponentRef, timerRef) => () => {
    var _a, _b;
    if ((_b = (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.canvasContext) === null || _b === void 0 ? void 0 : _b.canvasComponent)
        graphComponentRef.current.canvasContext.canvasComponent.mouseWheelBehavior =
            MouseWheelBehaviors.NONE;
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
        var _a, _b;
        if ((_b = (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.canvasContext) === null || _b === void 0 ? void 0 : _b.canvasComponent)
            graphComponentRef.current.canvasContext.canvasComponent.mouseWheelBehavior =
                MouseWheelBehaviors.ZOOM;
    }, 0);
    return false;
};
